(() => {
  if (customElements.get('pp-mobile-shortcuts')) return;
  customElements.define('pp-mobile-shortcuts', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.querySelectorAll('[data-widget]').forEach(link => {
        link.addEventListener('click', event => {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const target = document.querySelector(link.dataset.widget === 'rewards' ? '.Rise__widget-launcher.Rise__widget-launcher__Type__icon-text' : '#reamaze-widget');
          if (!target || typeof target.click !== 'function') return;
          try { target.click(); event.preventDefault(); } catch (_) { /* Keep the existing page link usable if the app cannot open. */ }
        }, { signal: this.events.signal });
      });
    }
    disconnectedCallback() { this.events?.abort(); }
  });
})();
